import Vue from 'vue';
import EventService from "@/services/EventService";
// import { indexById } from "@/components/Utils";

export const namespaced = true;


export const state = {
    customfields: [],
    // attendeefields: [],
    // organisationfields: [],
    // byId: {}
};

export const mutations = {
    SET_CUSTOMFIELDS(state, items) {
        state.customfields = items;
        // state.attendeefields = items.filter(field => field.display_on === "ATTENDEE")
        // state.organisationfields = items.filter(field => field.display_on === "ORGANISATION")
    },
    // SET_BYID(state, indexed) {
    //     state.byId = indexed;
    // },
    SET_FIELD(state, field) {
        const index = state.customfields.findIndex(item => item.id === field.id);

        if (index !== -1) {
            Vue.set(state.customfields, index, field);
        } else {
            state.customfields.push(field);
        }
    },
    // UPDATE_ATTENDEEFIELDS(state, items) {
    //     state.attendeefields = items;
    // },
    // UPDATE_ORGANISATIONFIELDS(state, items) {
    //     state.organisationfields = items;
    // },
};

export const actions = {
    async fetchCustomFields(context) {
        return EventService.getCustomFields()
            .then(response => {
                context.commit('SET_CUSTOMFIELDS', response.data);
                // context.commit('SET_BYID', indexById(response.data));
            })
            .catch(error => {
               console.log('getCustomFields failed: ', error.message)
            });
    },
    updateField(context, field) {
        context.commit('SET_FIELD', field);
    },
    // updateAttendeeFields(context, fields) {
    //     context.commit('UPDATE_ATTENDEEFIELDS', fields);
    // },
    // updateOrganisationFields(context, fields) {
    //     context.commit('UPDATE_ORGANISATIONFIELDS', fields);
    // },
    updateAllFields(context, fields) {
        context.commit('SET_CUSTOMFIELDS', fields);
    },
};

export const getters = {
    attendeeFields(state) {
        // return state.customfields.attendeefields;
        return state.customfields.filter(field => field.display_on === "ATTENDEE");
    },
    organisationFields(state) {
        // return state.customfields.organisationfields;
        return state.customfields.filter(field => field.display_on === "ORGANISATION");
    },
    searchableFields(state) {
        return state.customfields.filter(field => field.searchable);
    },
    allFields(state) {
        return state.customfields;
    },
};